export const JWT_KEY = 'X_ACCESS_TOKEN'

const GetToken = () => window.localStorage.getItem(JWT_KEY)

const SaveToken = (token) => {
    window.localStorage.setItem(JWT_KEY, token)
}

const DestroyToken = () => {
    window.localStorage.removeItem(JWT_KEY)
    window.location.reload()

}

export const JWTService = {
    SaveToken,
    GetToken,
    DestroyToken
  }
